<template>
    <div>
        <div
            class="dropzone-html d-flex flex-column align-center justify-center"
            @dragover.prevent
            @drop.prevent="onDropHtml"
            @click="!htmlFile && openInputHtml()"
        >
            <template v-if="!htmlFile">
                <v-icon color="primary" size="36">mdi-file-html</v-icon>
                <span class="mt-2" style="color: #444; font-size: 1rem">
                    Arrastra o haz clic para subir un archivo HTML
                </span>
                <input ref="fileInputHtml" type="file" accept=".html" style="display: none" @change="onAddHtml" />
            </template>
            <template v-else>
                <div class="file-preview-box d-flex align-center justify-space-between w-100">
                    <div class="d-flex align-center gap-2">
                        <v-icon color="accent" size="32">mdi-file-document-outline</v-icon>
                        <span style="color: #444; font-size: 1rem; font-weight: 500">{{ htmlFile.name }}</span>
                    </div>
                    <div class="d-flex align-center gap-1">
                        <v-btn icon small color="primary" @click.stop="onViewHtml">
                            <v-icon>mdi-eye</v-icon>
                        </v-btn>
                        <v-btn icon small color="error" @click.stop="onRemoveHtml">
                            <v-icon>mdi-close-circle</v-icon>
                        </v-btn>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'HtmlDropzone',
        props: {
            value: Object, // { file: File, content: String }
        },
        data() {
            return {
                htmlFile: null,
                htmlContent: '',
            };
        },
        watch: {
            value: {
                immediate: true,
                handler(val) {
                    if (val) {
                        this.htmlFile = val.file;
                        this.htmlContent = val.content;
                        this.$emit('getHtml', this.htmlContent);
                    } else {
                        this.htmlFile = null;
                        this.htmlContent = '';
                        this.$emit('getHtml', this.htmlContent);
                    }
                },
            },
        },
        methods: {
            openInputHtml() {
                const fileInput = this.$refs.fileInputHtml;
                if (fileInput) fileInput.click();
            },
            async onAddHtml(e) {
                const file = e.target.files[0];
                if (!file || file.type !== 'text/html') {
                    this.$toasted?.error('Solo se permite archivos HTML');
                    return;
                }
                this.htmlFile = file;
                this.htmlContent = await file.text();
                this.$emit('input', { file: this.htmlFile, content: this.htmlContent });
            },
            async onDropHtml(e) {
                const file = e.dataTransfer.files[0];
                if (!file || !file.name.endsWith('.html')) {
                    this.$toasted?.error('Solo se permite archivos HTML');
                    return;
                }
                this.htmlFile = file;
                this.htmlContent = await file.text();
                this.$emit('input', { file: this.htmlFile, content: this.htmlContent });
            },
            onRemoveHtml() {
                this.htmlFile = null;
                this.htmlContent = '';
                this.$refs.fileInputHtml.value = null;
                this.$emit('input', null);
            },
            onViewHtml() {
                if (!this.htmlContent) return;
                // Abrir ventana nueva con tamaño y sin barra de direcciones
                const win = window.open('', 'htmlPreview', 'menubar=no,toolbar=no,location=no,status=no');
                win.document.write(this.htmlContent);
                win.document.close();
            },
        },
    };
</script>

<style scoped>
    .dropzone-html {
        border: 2px dashed #2d6cdf;
        border-radius: 12px;
        background: #f9f9f9;
        min-height: 90px;
        cursor: pointer;
        transition: border-color 0.2s;
        padding: 0.5rem 1rem;
        position: relative;
    }
    .dropzone-html:hover {
        border-color: #2846f9;
    }
    .file-preview-box {
        background: #fff;
        border-radius: 10px;
        box-shadow: 0 2px 8px rgba(44, 76, 223, 0.07);
        padding: 0.75rem 1.25rem;
        margin: 0.5rem 0;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
</style>
